<template>
  <div class='renewalWhitelist'>
    <div class="top">
      <p class='text'>当前套餐：{{renewalWhitelistData.packageName}}</p>
      <div class='switch_body'>
        续费白名单：
        <el-switch v-model="whitelistValue" />
      </div>
    </div>

    <div class="addButton"
         style="justify-content: space-between">
      <el-button type="primary"
                 :disabled="delSelectionList.length === 0"
                 @click="batchDelFun">批量删除</el-button>
      <el-button type="primary"
                 @click="showForm">新增</el-button>
    </div>

    <filter-panel :data="groups"
                  @search="filterChange"></filter-panel>

    <data-list :data="data"
               :columns="column"
               :table-style="{ name: 'mixture' }"
               :selection="true"
               :page="page"
               :page-size="page.pageSize"
               :loading="loading"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @selection-change="delSelectionChange"></data-list>

    <div class="addButton">
      <el-button type="danger"
                 @click="cancel">取消</el-button>
      <el-button type="primary"
                 @click="confirm">确定</el-button>
    </div>

    <!-- 白名单添加客户表单弹框 -->
    <el-dialog title="添加客户"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               width="800px">
      <div class="formBody">
        <div class="left">
          <skyTextarea v-model="customerName"
                       placeholder="请输入客户名称，多个客户用换行分隔"
                       rows="7"></skyTextarea>
          <div class="checkBut">
            <el-button type="primary"
                       size="small"
                       placeholder="备注"
                       @click="checkFun">多服务单校验</el-button>
          </div>
          <skyTextarea v-model="remark"
                       placeholder="备注"
                       rows="4"></skyTextarea>
        </div>
        <div class="right">
          <div>
            以下客户有多个服务单，请选择目标服务单
          </div>
          <div class="servicesList">
            <div v-for="item in serviceList"
                 :key="item.id"
                 class="servicesList_item">
              <p class="servicesList_p">{{item.name}}</p>
              <el-checkbox-group v-model="item.serviceIdList">
                <el-checkbox v-for="_item in item.serviceList"
                             :label="_item.id"
                             :key="_item.id">{{`${_item.serviceCode}（${_item.domain || '-'}）`}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="formCancel">取 消</el-button>
        <el-button type="primary"
                   :disabled="!checkStatus"
                   @click="formConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 备注修改弹框 -->
    <el-dialog title="修改备注"
               :visible.sync="editDialogVisible"
               :close-on-click-modal="false"
               width="400px">
      <div class="formBody">
        <skyTextarea v-model="remarkEdit"
                     placeholder="备注"
                     rows="4"></skyTextarea>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editFormCancel">取 消</el-button>
        <el-button type="primary"
                   @click="editFormConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import skyTextarea from '@/components/iglobalwin/formComponents/sky-textarea.vue';
import setmeal from '@/backend/services/account/setmeal.js';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';

const list = listPageCreate({
  searchConfig: {
    api: api.setmeal.renewWhiteList,
    method: 'POST',
  },
  getQuery (obj, that) {
    let { id } = that.$route.query
    return _.assign(obj, {
      packageId: id,
    })
  }
});

export default {
  name: 'renewalWhitelist',
  components: {
    skyTextarea,
    filterPanel
  },
  mixins: [list],
  data () {
    let that = this
    return {
      renewalWhitelistData: {},
      whitelistValue: true,
      dialogVisible: false,
      checkStatus: false,
      customerName: '',
      remark: '',
      remarkEdit: '',
      serviceList: [],
      editId: '',
      editDialogVisible: false,
      delSelectionList: [],
      column: [
        {
          label: '客户名称',
          bind: 'customerName',
        },
        {
          label: '服务单',
          bind: 'serviceCode',
        },
        {
          label: '操作人',
          bind: 'modifierName',
        },
        {
          label: '最近操作时间',
          bind: 'modifiedTime',
        },
        {
          label: '备注',
          bind: 'remark',
        },
        {
          label: '操作',
          type: 'btnClick',
          align: 'center',
          style: 'text',
          bind () {
            let arr = [
              {
                text: '备注',
                async trigger (row) {
                  let { remark, id } = row
                  that.editDialogVisible = true
                  that.remarkEdit = remark
                  that.editId = id
                },
              },
              {
                text: '删除',
                async trigger (row) {
                  that.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                    .then(() => {
                      that.delete(row)
                    })
                    .catch(() => { })
                },
              },
            ];
            return arr;
          },
        },
      ],
      groups: {
        others: [
          {
            tagName: 'sky-input',
            placeholder: '客户名称',
            label: '客户名称',
            prop: 'customerName',
            value: '',
          },
        ],
      }
    }
  },

  mounted () {
    this.getSetMealDetail()
  },
  methods: {
    // 获取套餐配置详情
    async getSetMealDetail () {
      let { packageVersionId, flagRenewalWhiteList } = this.$route.query
      let res = await setmeal.setMealDetail(packageVersionId);
      this.renewalWhitelistData = res.data
      this.whitelistValue = flagRenewalWhiteList
      this.query()
    },
    // 显示新增黑名单弹窗
    showForm () {
      this.customerName = ''
      this.remark = ''
      this.serviceList = []
      this.dialogVisible = true
      this.checkStatus = false
    },
    // 取消操作
    cancel () {
      this.$router.push({
        name: 'saas',
      });
    },
    // 确定操作
    async confirm () {
      try {
        let { id } = this.$route.query
        await setmeal.allowRenewWhiteList({
          id
        })
        this.$router.push({
          name: 'saas',
        });
      } catch (error) {
        this.$message({
          message: '修改失败',
          type: 'warning',
        });
      }
    },
    // 多服务单校验操作函数
    async checkFun () {
      try {
        let customerNameList = this.customerName.split('\n')
        let res = await setmeal.manyServiceList({
          customerNameList
        })
        this.serviceList = res.data.map(item => {
          return {
            ...item,
            serviceIdList: item.serviceList.map(_item => {
              return _item.id
            })
          }
        })
        this.checkStatus = true
      } catch (error) {
        this.$message({
          message: '校验失败',
          type: 'warning',
        });
      }
    },
    // 新增弹窗取消操作
    formCancel () {
      this.dialogVisible = false
      this.checkStatus = false
    },
    // 新增弹窗确定操作
    async formConfirm () {
      try {
        let { serviceList, remark, customerName } = this
        let customerNameList = customerName.split('\n')
        let { id: packageId } = this.$route.query
        let serviceIdList = [];
        serviceList.forEach(item => {
          item.serviceIdList.forEach(_item => {
            serviceIdList.push(_item)
          })
        })
        await setmeal.addRenewWhiteList({
          customerNameList,
          packageId,
          remark,
          serviceIdList
        })
        this.page = {
          currentPage: 1,
          totalRecords: 0,
          pageSize: 10,
        }
        this.query()
        this.$message({
          message: '新增成功',
          type: 'success',
        });
        this.dialogVisible = false
      } catch (error) {
        this.$message({
          message: '新增失败',
          type: 'warning',
        });
      }
    },
    // 删除操作
    async delete (row) {
      try {
        let { id } = row
        await setmeal.deleteRenewWhiteList({
          id
        })
        this.query()
      } catch (error) {
        this.$message({
          message: '删除失败',
          type: 'warning',
        });
      }
    },
    // 备注弹窗取消操作
    editFormCancel () {
      this.editDialogVisible = false
    },
    // 备注弹窗确定操作
    async editFormConfirm () {
      try {
        let { remarkEdit: remark, editId: id } = this
        await setmeal.editRenewWhiteList({
          id,
          remark
        })
        this.query()
        this.editDialogVisible = false
      } catch (error) {
        this.$message({
          message: '新增失败',
          type: 'warning',
        });
      }
    },
    delSelectionChange (list) {
      this.delSelectionList = list
    },
    // 批量删除点击事件
    batchDelFun () {
      this.$confirm('是否批量删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.batchDel()
        })
        .catch(() => { })
    },
    async batchDel () {
      try {
        let { delSelectionList } = this
        let idList = delSelectionList.map(item => {
          return item.id
        })
        await setmeal.batchDeleteRenewWhiteList({
          idList
        })
        this.query()
      } catch (error) {
        this.$message({
          message: '新增失败',
          type: 'warning',
        });
      }

    }
  }
}
</script>

<style lang='scss' scoped>
.renewalWhitelist {
	.top {
		width: 100%;
		background-color: #fff;
		padding: 20px 20px;

		.text {
			font-size: 20px;
			font-weight: 600;
		}

		.switch_body {
			font-size: 16px;
			font-weight: 500;
			margin-top: 20px;
			display: flex;
			flex-direction: row;
			align-items: center;
		}
	}

	.formBody {
		display: flex;

		.left {
			flex: 1;
			width: 0;
			margin-right: 10px;
			margin-top: 26px;
		}

		.right {
			flex: 1;
			width: 0;
			display: flex;
			flex-direction: column;

			.servicesList {
				height: 307px;
				margin-top: 10px;
				border: 1px solid #dcdfe6;
				border-radius: 4px;
				padding: 10px;
				overflow-y: auto;

				// 改变滚动条样式
				&::-webkit-scrollbar {
					width: 5px;
				}

				&::-webkit-scrollbar-thumb {
					background-color: #e8e8e8;
					height: 50px;
					border-radius: 6px;
				}

				&::-webkit-scrollbar-track {
					background-color: #fff;
					border-radius: 2px;
				}

				.servicesList_item {
					margin: 5px 0;

					.servicesList_p {
						font-size: 16px;
						margin-bottom: 5px;
					}

					::v-deep  .el-checkbox-group {
						margin-left: 10px;
					}
				}
			}
		}
	}

	.addButton {
		width: 100%;
		height: 60px;
		margin: 10px 0;
		padding: 0 20px;
		padding-bottom: 10px;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
	}

	.checkBut {
		width: 100%;
		margin: 10px 0;
		background-color: #fff;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
	}
}
</style>
